module.exports = __webpack_public_path__ + "static/media/logo_horiz.91786fd9.png";